import { OnlyOfficeFileSettingsFragment } from "gql/graphql";

export function extractFilePropertiesFromOnlyOfficeFileSettings(
  fileSettings?: OnlyOfficeFileSettingsFragment,
) {
  const editFileUrl = fileSettings ? new URL(fileSettings.editFileUrl) : null;

  const fileRefAsString = editFileUrl
    ? editFileUrl.searchParams.get("file")
    : null;

  const filename = fileRefAsString
    ? new URL(fileRefAsString).searchParams.get("name")
    : null;

  const match = filename?.match(/\.([a-zA-Z0-9]+)$/);

  const extension = match ? match[1] : null;

  return {
    filename,
    extension,
  };
}
